export function buildRouteLabel(route: string, city: string): string {
  const [departureCode, arrivalCode] = route.split("-");
  const [departureCity, arrivalCity] = city.split("-");
  if (!departureCode || !arrivalCode || !departureCity || !arrivalCity) {
    return route;
  }
  return `${departureCity} (${departureCode}) → ${arrivalCity} (${arrivalCode})`;
}
